<template>

  <div ref="box" :class="['slide-in', `slide-in--${direction}`]">
    <slot />
  </div>

</template>

<script>

  export default {

    props: {
      direction: {
        type: String,
        default: 'left'
      }
    },

    mounted() {
      const element = this.$refs['box'];

      setTimeout(() => element.classList.add('slide-in--visible'), 10);

    }
  }

</script>

<style scoped lang="scss">

  .slide-in {

    transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;

    &--left {
      transform: translateX(110%);
    }

    &--right {
      transform: translateX(-110%);
    }

    &--up {
      transform: translateY(1300px);
    }

    &--visible {
      transform: none;
    }

  }

</style>